module.exports = __webpack_public_path__ + "561e7fc70c4a4311c44cb62df18ce1d9.svg";